import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { vacationsApi } from 'app/services/edpApiV1/vacations';
import { consultationsApi, VialatorsResponse } from 'app/services/edpApiV1/consultations';

const initialState: VialatorsResponse = [
  {
    id: 0,
    name: '',
    violationReasons: [
      {
        id: 0,
        violatorId: 0,
        name: '',
      },
    ],
  },
];

export const violatorsSlice = createSlice({
  name: 'violators',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        consultationsApi.endpoints.violators.matchFulfilled,
        (_, { payload }: PayloadAction<VialatorsResponse>) => payload,
      )
      .addMatcher(vacationsApi.endpoints.vacations.matchRejected, () => initialState);
  },
});

const violators = (state: RootState) => state.entities.consultations.violators;
const getViolators = createSelector(violators, state => state);

export const selectors = { getViolators };
export const actions = violatorsSlice.actions;
export const reducer = violatorsSlice.reducer;
